import { IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { ExpertPage, PastConversationsPage } from '../../pages/index';

export const CustomerLayout = () => {
  return (
    <IonRouterOutlet>
      <Switch>
        <Route
          path="/customer/past-conversations"
          component={PastConversationsPage}
        />
        <Route path="/customer/experts/:id" component={ExpertPage} />
        <Redirect exact from="/customer/experts" to="/character/blaen" />
        <Redirect from="/customer" to="/customer/experts" />
      </Switch>
    </IonRouterOutlet>
  );
};
